import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import template from './bulk-edit-bid-panel-template.pug';
import { BulkEditPanelBase } from './bulk-edit-panel-base';
import { completeToast, failedToast } from './bulk-edit-toast';
import { BidStrategyView } from '../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const TITLE_MAP = {
  hotel: {
    singular: 'HotelCenter_Overview_Edit_Change_Bids_Label_Hotel',
    plural: 'HotelCenter_Overview_Edit_Change_Bids_Label_Hotels',
  },
  hotelGroup: {
    singular: 'HotelCenter_Overview_Edit_Change_Bids_Label_HotelGroup',
    plural: 'HotelCenter_Overview_Edit_Change_Bids_Label_HotelGroups',
  },
};


/**
 * Class representing a panel for bulk bid edit
 * @extends View
 * @returns {BulkEditBidPanel} - BulkEditBidPanel
 */
export default class BulkEditBidPanel extends BulkEditPanelBase {
  initialize({
    viewConfig,
    selectedRowCount,
    gridName,
    serverContext = { DynamicPermissions: {} },
  }) {
    let selectedItems = [];
    this.mainGrid = viewConfig.grid;
    selectedItems = this.mainGrid.gridView.selectedItems();
    this.mainGrid.gridView.on('didSelect', () => {
      this.onSelected();
    });
    this.onEvent();
    this.i18n = i18n;
    this.scope = 'hotel';
    if (gridName === 'HotelGroupGrid') {
      this.scope = 'hotelGroup';
    }

    super.initialize({
      completeToast: _.partial(completeToast, 'HotelCenter_BulkEdit_Update_Bid_Success', 'HotelCenter_BulkEdit_Update_Bid_Partial_Success'),
      failedToast: _.partial(failedToast, 'HotelCenter_BulkEdit_Update_Bid_Failed'),
      activityName: 'bulkEditHotelBid',
    });

    const isPPSPhase2Pilot = serverContext.DynamicPermissions.ReconciliationReport;
    this.bidStrategyView = new BidStrategyView({ isReadonly: false, enablePPS: isPPSPhase2Pilot });
    this.setChild('bid-strategy-view', this.bidStrategyView);

    this.setState({
      scope: this.scope,
      errors: [],
    });
    this.updateSelection({
      selectionCount: selectedRowCount || 0,
      selectedItems,
      filter: null,
    });
  }

  getBatchAction(state) {
    const {
      bid,
    } = state;
    const value = _.isNull(bid.Amount) ? null : JSON.stringify(bid);
    const batchActions = {
      Actions: [{
        '@odata.type': '#Model.TextAction',
        ActionType: 'Set',
        Options: 'None',
        SearchString: null,
        Value: value,
        Property: 'Bid',
      }],
      EditCopy: false,
    };

    return batchActions;
  }
  onSelected = () => {
    const selectedItems = this.mainGrid.gridView.selectedItems();
    const selectionCount =
      this.mainGrid.crossPageSelectAll && this.mainGrid.crossPageSelectAll.isAllSelected ?
        this.mainGrid.crossPageSelectAll.viewModel.totalRowsTotalPageCount() :
        selectedItems.length;
    const filter = null;

    this.updateSelection({ selectionCount, selectedItems, filter });
  }
  onCancel() {
    super.onCancel();
  }
  updateSelection({
    selectionCount,
    selectedItems,
    filter,
  }) {
    const titleKey = TITLE_MAP[super.getState().scope][selectionCount === 1 ? 'singular' : 'plural'];
    const title = this.i18n.getString(titleKey)
      .replace('{0}', selectionCount);

    this.setState({
      selectionCount,
      selectedItems,
      filter,
      title,
      showRequestError: false,
    });
    this.bulkEditView.$('.preview-container').hide();
    this.bulkEditView.viewModel.disableAction(selectionCount === 0);
  }

  renderTrunk() {
    super.renderTrunk();
    this.$('.bulk-edit-container').append(this.bulkEditView.el);
  }

  get template() {
    return template;
  }

  getState() {
    const state = super.getState();
    const { bid } = this.bidStrategyView.getState();

    return _.defaults({
      bid,
    }, state);
  }

  validate() {
    const isBidValid = this.bidStrategyView.getState().isValid;

    if (!isBidValid) {
      this.bidStrategyView.setState({ showError: true });
    }
    return isBidValid;
  }
}
